// Global quantity selector handler
document.addEventListener("DOMContentLoaded", function () {
  // Find all forms that might have quantity selectors
  const productForms = document.querySelectorAll(
    'form[data-type="add-to-cart-form"]'
  );

  productForms.forEach((form) => {
    // Find quantity inputs associated with this form
    const formId = form.id;
    const quantityInputs = document.querySelectorAll(
      `input[name="quantity"][form="${formId}"], .modern-quantity-selector .quantity-input[form="${formId}"]`
    );

    if (quantityInputs.length === 0) return;

    // Override form submission
    form.addEventListener("submit", function (e) {
      // Get the first visible quantity input
      const activeQuantityInput = quantityInputs[0];
      const quantity = parseInt(activeQuantityInput.value) || 1;

      // Remove any existing hidden quantity inputs
      form
        .querySelectorAll('input[type="hidden"][name="quantity"]')
        .forEach((input) => {
          input.remove();
        });

      // Create a new hidden input with the current quantity
      const qtyInput = document.createElement("input");
      qtyInput.type = "hidden";
      qtyInput.name = "quantity";
      qtyInput.value = quantity;

      // Add the hidden input to the form
      form.appendChild(qtyInput);
    });
  });

  // Handle responsive product titles
  function handleResponsiveProductTitles() {
    const productTitles = document.querySelectorAll(
      ".shop-product-title[data-font-size][data-mobile-font-size]"
    );

    productTitles.forEach((title) => {
      function adjustTitleFontSize() {
        const desktopSize = title.getAttribute("data-font-size");
        const mobileSize = title.getAttribute("data-mobile-font-size");

        if (window.innerWidth <= 767) {
          title.style.setProperty("font-size", `${mobileSize}px`, "important");
        } else {
          title.style.setProperty("font-size", `${desktopSize}px`, "important");
        }
      }

      // Run immediately
      adjustTitleFontSize();

      // Add resize event listener if not already added
      if (!title.hasAttribute("data-resize-listener-added")) {
        window.addEventListener("resize", adjustTitleFontSize);
        title.setAttribute("data-resize-listener-added", "true");
      }
    });
  }

  // Initialize responsive product titles
  handleResponsiveProductTitles();

  // Handle FAQ accordions - updated to work with hardcoded FAQ containers
  function initFaqAccordions() {
    console.log('Initializing FAQ accordions...');
    
    // Handle product-faq containers (dynamic ones)
    const faqContainers = document.querySelectorAll(".product-faq");
    console.log('Found product-faq containers:', faqContainers.length);
    
    faqContainers.forEach((faqContainer) => {
      const faqId = faqContainer.id;
      if (!faqId) return;

      const faqItems = faqContainer.querySelectorAll(".faq-item");
      const innerFaqContainer = faqContainer.querySelector(".faq-container");
      const isAccordion =
        innerFaqContainer &&
        innerFaqContainer.getAttribute("data-accordion") === "true";

      faqItems.forEach((item) => {
        const question = item.querySelector(".faq-question");
        if (!question) return;

        // Only add click listener if it doesn't already have one
        if (!question.hasAttribute("data-click-listener-added")) {
          question.setAttribute("data-click-listener-added", "true");

          question.addEventListener("click", () => {
            const isActive = item.classList.contains("active");

            // Close all other items first if accordion mode is enabled
            if (isAccordion && !isActive) {
              faqItems.forEach((otherItem) => {
                otherItem.classList.remove("active");
              });
            }

            // Toggle the clicked item
            item.classList.toggle("active");
          });
        }
      });
    });

    // Handle hardcoded FAQ containers (both desktop in video column and mobile)
    const hardcodedFaqContainers = document.querySelectorAll(".faq-wrapper .faq-container");
    console.log('Found hardcoded FAQ containers:', hardcodedFaqContainers.length);
    
    hardcodedFaqContainers.forEach((faqContainer, containerIndex) => {
      const faqItems = faqContainer.querySelectorAll(".faq-item");
      console.log(`Container ${containerIndex} has ${faqItems.length} FAQ items`);

      faqItems.forEach((item, itemIndex) => {
        const question = item.querySelector(".faq-question");
        const toggle = question ? question.querySelector(".faq-toggle") : null;
        
        if (!question) {
          console.warn(`FAQ item ${itemIndex} missing question element`);
          return;
        }

        // Only add click listener if it doesn't already have one
        if (!question.hasAttribute("data-click-listener-added")) {
          question.setAttribute("data-click-listener-added", "true");
          console.log(`Adding click listener to FAQ item ${itemIndex}`);

          question.addEventListener("click", (e) => {
            e.preventDefault();
            e.stopPropagation();
            
            console.log(`FAQ item ${itemIndex} clicked`);
            
            // Toggle the clicked item
            const wasActive = item.classList.contains("active");
            item.classList.toggle("active");
            const isNowActive = item.classList.contains("active");
            
            console.log(`FAQ item ${itemIndex} state changed: ${wasActive} -> ${isNowActive}`);
            
            // Update toggle icon
            if (toggle) {
              toggle.textContent = isNowActive ? "−" : "+";
            }
          });
        } else {
          console.log(`FAQ item ${itemIndex} already has click listener`);
        }
      });
    });
    
    console.log('FAQ initialization complete');
  }

  // Initialize FAQ accordions
  setTimeout(() => {
    initFaqAccordions();
  }, 100);
});

// Other product details JavaScript can go here

document.addEventListener("DOMContentLoaded", function () {
  setTimeout(function () {
    document.querySelectorAll(".kaching-bundles__bar").forEach(function (bar) {
      bar.addEventListener("click", function () {
        // Get pricing values
        const pricingContainer = bar.querySelector(
          ".kaching-bundles__bar-pricing"
        );
        const priceElement = pricingContainer.querySelector(
          ".kaching-bundles__bar-price"
        );
        const fullPriceElement = pricingContainer.querySelector(
          ".kaching-bundles__bar-full-price"
        );

        const price = priceElement ? priceElement.textContent.trim() : null;
        const fullPrice = fullPriceElement
          ? fullPriceElement.textContent.trim()
          : null;

        // Find parent product info block
        const productInfo = bar.closest(".shop-product-info");

        if (productInfo && price && fullPrice) {
          const buttonTextContainer = productInfo.querySelector(
            ".shop-add-to-cart-button .button-text"
          );
          if (buttonTextContainer) {
            setTimeout(function () {
              buttonTextContainer.innerHTML = `Add to Cart - ${price} <span class="compare-price">${fullPrice}</span>`;
            }, 50);
          }
        }
      });
    });
  }, 1000);
});

  // Transform Development Status into Roadmap
  function transformToRoadmap() {
    console.log('Transforming development status to roadmap...');
    
    const constructionTitles = document.querySelectorAll('.construction-title');
    const constructionTimelines = document.querySelectorAll('.construction-timeline');
    const constructionBenefits = document.querySelectorAll('.construction-benefits');
    
    constructionTitles.forEach(title => {
      if (title.textContent.includes('V2 Development Status') || title.textContent.includes('Development Roadmap')) {
        title.innerHTML = '🚧 Development Roadmap';
      }
    });
    
    constructionTimelines.forEach(timeline => {
      timeline.className = 'roadmap-timeline';
      timeline.innerHTML = `
        <div class="timeline-item">
          <div class="timeline-icon">🔧</div>
          <div class="timeline-text">
            <strong>Theme Updater + License Manager</strong>
            <span>Automatic updates and licensing system for seamless theme management</span>
          </div>
        </div>
        
        <div class="timeline-item">
          <div class="timeline-icon">📚</div>
          <div class="timeline-text">
            <strong>Template Library</strong>
            <span>Collection of pre-built page templates for quick store setup</span>
          </div>
        </div>
        
        <div class="timeline-item">
          <div class="timeline-icon">🎯</div>
          <div class="timeline-text">
            <strong>Finished V1</strong>
            <span>Complete first version with all core features and optimizations</span>
          </div>
        </div>
        
        <div class="timeline-item">
          <div class="timeline-icon">🚀</div>
          <div class="timeline-text">
            <strong>Start V2 Development</strong>
            <span>Begin development of advanced features and enhanced functionality</span>
          </div>
        </div>
      `;
    });
    
    // Hide benefits section
    constructionBenefits.forEach(benefits => {
      benefits.style.display = 'none';
    });
    
    // Add roadmap CSS if not already added
    if (!document.querySelector('#roadmap-styles')) {
      const style = document.createElement('style');
      style.id = 'roadmap-styles';
      style.textContent = `
        .roadmap-timeline {
          display: flex;
          flex-direction: column;
          gap: 12px;
          position: relative;
          z-index: 2;
        }
        
        .timeline-item {
          display: flex;
          align-items: flex-start;
          gap: 6px;
          padding: 12px 16px;
          border-radius: 8px;
          border: 1px solid rgba(255, 255, 255, 0.1);
          background: rgba(255, 255, 255, 0.05);
          backdrop-filter: blur(10px);
        }
        
        .timeline-icon {
          font-size: 20px;
          margin-right: 0px;
          filter: drop-shadow(0 1px 2px rgba(0, 0, 0, 0.5));
          flex-shrink: 0;
        }
        
        .timeline-text {
          display: flex;
          flex-direction: column;
          gap: 4px;
          flex: 1;
        }
        
        .timeline-text strong {
          color: #ffffff !important;
          font-size: 15px;
          font-weight: 700;
          line-height: 1.3;
        }
        
        .timeline-text span {
          color: #ffffff !important;
          font-size: 13px;
          font-weight: 400;
          line-height: 1.4;
          opacity: 0.8;
        }
        
        @media (max-width: 768px) {
          .roadmap-timeline {
            gap: 10px;
          }
          
          .timeline-item {
            padding: 10px 14px;
          }
          
          .timeline-icon {
            font-size: 18px;
          }
          
          .timeline-text strong {
            font-size: 14px;
          }
          
          .timeline-text span {
            font-size: 12px;
          }
        }
      `;
      document.head.appendChild(style);
    }
    
    console.log('Roadmap transformation complete');
  }

  // Initialize roadmap transformation
  setTimeout(() => {
    transformToRoadmap();
  }, 200);
